import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { GeneralService } from 'src/app/Service/general.service';

@Component({
  selector: 'app-view-lrs-document',
  templateUrl: './view-lrs-document.component.html',
  styleUrls: ['./view-lrs-document.component.scss']
})
export class ViewLrsDocumentComponent implements OnInit {

  breadCrumbItems: Array<{}>;
  fileUrl:any;
  UserId: any;
  url: any;
  constructor(private router: Router, private generalService: GeneralService, private sanitizer :DomSanitizer) { 
   
  let a = this.router.getCurrentNavigation().extras
  if(a){
    if(a.state){
      this.UserId = a.state.UserId
      this.fileUrl = a.state.URL
      localStorage.setItem('UserId',this.UserId)
      localStorage.setItem('URL',this.fileUrl)
    }
  }

  if(localStorage.getItem('URL')){
    this.fileUrl = localStorage.getItem('URL')
  }
  if(localStorage.getItem('UserId')){
    this.UserId = localStorage.getItem('UserId')
  }
  this.breadCrumbItems = [{label: 'LRS Requested Documents' , path:'/users/lrs-user-details'},
  {label:'View LRS Document', path:`/users/view-document/${this.UserId}`}]
  console.log('UserID',this.UserId)
  console.log('File URl',this.fileUrl)
  }

  ngOnInit() {
    this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.fileUrl)
  }
  // UserLrsdetails(){
  //   this.generalService.getLRSUserList(this.UserId).subscribe((res:any) =>{
      
  //   })
  // }
}
